module.exports = __webpack_public_path__ + "img/EmptyInbox.1ab79078.png";